//libraries
import Vue from 'vue'
import axios from 'axios'
import { EventBus } from '@/helpers/eventBus'

let resource = 'block'
let resource_name = 'bloque'
let resource_name_plural = 'bloques'

let state = {
  selected_block: {
    block_id: null,
    user_attribute_id: null,
    type: null,
    sequence_id: null,
    name: "",
    kpi_name: "",
    kpi_description: "",
    is_important: false,
    is_kpi: false,
    Templates: []
  },
  favorite_blocks: []
}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success) {
        let block = state.blocks.find(b => b.block_id == params.block_id)
        if (block) {
          for (let key in params) {
            if (block[key]) {
              block[key] = params[key]
            }
          }

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${params.block_id}`)
          })
        }

        if (params.callback) params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
        commit('removeBlock', params.block_id)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  setStateBlocks ({ commit }, blocks) {
    commit('setItems', blocks)
  },
  setBlock ({ commit }, block) {
    commit('setBlock', block)
  },
  getTemplateConnector ({ state }, data) {
    let block_id = data.block_id,
        template_id = data.template_id,
        template_connector_id = data.connector_id

    let block = state.blocks.find(b => b.block_id == block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == template_id)
      if (template) {
        let template_connector_found = template.Template_Connectors.find(tc => {
          return tc.template_connector_id == template_connector_id
        })
        if (data.callback) data.callback(template_connector_found)
      }
    }
  },
  getElementConnector ({ state }, data) {
    let block_id = data.block_id,
        template_id = data.template_id,
        element_id = data.element_id,
        element_connector_id = data.connector_id

    let block = state.blocks.find(b => b.block_id == block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == template_id)
      if (template) {
        let element = template.Elements.find(e => e.element_id == element_id)
        if (element) {
          let element_connector_found = element.Element_Connectors.find(ec => ec.element_connector_id == element_connector_id)
          if (data.callback) data.callback(element_connector_found)
        }
      }
    }
  },
  async sortTemplates ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/sort_templates`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando actualizando posición de templates.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando posición de templates.`})
      console.error(e)
    }
  },
  async favorites ({ commit }, params) {
    try {
      commit('setFavoriteBlocks', [])
      let res = await Vue.request.get(`account/${params.account_id}/favorite_${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setFavoriteBlocks', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural} favoritos.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name} favoritos.`})
      console.error(e)
    }
  },
  async setPlatform ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/setPlatform`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error en plataforma del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error en plataforma del ${resource_name}.`})
      console.error(e)
    }
  },
  async associateSequence ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/associateSequence`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error asociando secuencia de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error asociando secuencia de ${resource_name}.`})
      console.error(e)
    }
  },
  async disassociateSequence ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/disassociateSequence`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error desasociando secuencia de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error desasociando secuencia de ${resource_name}.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  setBlock (state, item) {
    let index = state.blocks.findIndex(b => b.block_id == item.block_id)
    if(index >= 0) {
      state.blocks.splice(index, 1, item)
    } else {
      state.blocks.push(item)
    }
  },
  setSelectedBlock (state, selected_block) {
    state.selected_block = selected_block || null
  },
  appendBlock (state, block) {
    state.blocks.push(block)
  },
  removeBlock (state, block_id) {
    let blockIndex = state.blocks.findIndex(b => b.block_id == block_id)
    if (blockIndex >= 0) {
      let block = state.blocks[blockIndex]

      for (let template of block.Templates) {
        for (let template_connector of template.Template_Connectors) {
          EventBus.$emit('jsplumb:destroyEndpoint', `template_connector_${template_connector.template_connector_id}`)
        }

        for (let element of template.Elements) {
          for (let element_connector of element.Element_Connectors) {
            EventBus.$emit('jsplumb:destroyEndpoint', `element_connector_${element_connector.element_connector_id}`)
          }
        }
      }

      state.blocks.splice(blockIndex, 1)
      EventBus.$emit('jsplumb:destroyEndpoint', `block_${block.block_id}`)
      Vue.prototype.$nextTick(() => {
        EventBus.$emit('jsplumb:repaint')
      })
    }
  },
  appendTemplate (state, newTemplate) {
    let block = state.blocks.find(b => b.block_id == newTemplate.block_id)
    if (block) {
      if (newTemplate.index >= 0) {
        block.Templates.splice(newTemplate.index, 0, newTemplate)
      } else {
        let index = block.Templates.findIndex(el => el.template_id == newTemplate.template_id)
        if(index >= 0) {
          block.Templates.splice(index, 1, newTemplate)
        } else {
          block.Templates.push(newTemplate)
        }
      }

      Vue.prototype.$nextTick(() => {
        EventBus.$emit('jsplumb:repaint', `block_${newTemplate.block_id}`)
        EventBus.$emit('jsplumb:createTemplateConnectorEndpoint', newTemplate.Template_Connectors.map(tc => tc.template_connector_id))
      })
    }
  },
  updateTemplate (state, updatedTemplate) {
    const block = state.blocks.find(b => b.block_id == updatedTemplate.block_id)

    if (block && block.Templates) {
      try {
        const templateIndex = block.Templates.findIndex(t => t.template_id == updatedTemplate.template_id)

        if (templateIndex >= 0) {
          block.Templates.splice(templateIndex, 1, updatedTemplate)

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${updatedTemplate.block_id}`)
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  deleteTemplate (state, template) {
    let block = state.blocks.find(b => b.block_id == template.block_id)
    if (block && block.Templates) {
      let templateIndex = block.Templates.findIndex(t => t.template_id == template.template_id)
      if (templateIndex >= 0) {
        for (let template_connector of block.Templates[templateIndex].Template_Connectors) {
          EventBus.$emit('jsplumb:destroyEndpoint', `template_connector_${template_connector.template_connector_id}`)
        }

        for (let element of block.Templates[templateIndex].Elements) {
          for (let element_connector of element.Element_Connectors) {
            EventBus.$emit('jsplumb:destroyEndpoint', `element_connector_${element_connector.element_connector_id}`)
          }
        }

        block.Templates.splice(templateIndex, 1)

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${template.block_id}`)
        })
      }
    }
  },
  appendTemplateConnector (state, template_connector) {
    let block = state.blocks.find(b => b.block_id == template_connector.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == template_connector.template_id)
      if (template) {
        template_connector.isNew = true
        template.Template_Connectors.push(template_connector)

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${template_connector.block_id}`)
          EventBus.$emit('jsplumb:createTemplateConnectorEndpoint', template.Template_Connectors.map(tc => tc.template_connector_id))
        })
      }
    }
  },
  appendSelectedBlockTemplateConnector(state, templateConnector) {
    const template = state.selected_block.Templates.find(({ template_id: templateId }) => {
      return templateId === templateConnector.template_id
    })

    if (template) {
      const connector = template.Template_Connectors.find(({ template_connector_id }) => {
        return template_connector_id === templateConnector.template_connector_id
      })

      if (connector) return

      templateConnector.isNew = true

      template.Template_Connectors.push(templateConnector)
    }
  },
  updateTemplateConnector (state, template_connector) {
    const block = state.blocks.find(b => b.block_id == template_connector.block_id)

    if (block && block.Templates) {
      try {
        const template = block.Templates.find(t => t.template_id == template_connector.template_id)

        if (template) {
          let template_connector_index = template.Template_Connectors.findIndex(tc => tc.template_connector_id == template_connector.template_connector_id)
          if (template_connector_index >= 0) {
            template.Template_Connectors.splice(template_connector_index, 1, template_connector)
          }

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${template_connector.block_id}`)
            EventBus.$emit('connector:change', {
              sourceId: `template_connector_${template_connector.template_connector_id}`,
              targetId: `block_${template_connector.next_block_id}`,
              connector: template_connector
            })
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  deleteTemplateConnector (state, template_connector) {
    let block = state.blocks.find(b => b.block_id == template_connector.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == template_connector.template_id)
      if (template) {
        let template_connector_index = template.Template_Connectors.findIndex(tc => tc.template_connector_id == template_connector.template_connector_id)
        if (template_connector_index >= 0) {
          EventBus.$emit('jsplumb:destroyEndpoint', `template_connector_${template_connector.template_connector_id}`)
          template.Template_Connectors.splice(template_connector_index, 1)
        }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${template_connector.block_id}`)
        })
      }
    }
  },
  deleteSelectedBlockTemplateConnector(state, templateConnector) {
    const template = state.selected_block.Templates.find(({ template_id: templateId }) => {
      return templateId === templateConnector.template_id
    })

    if (template) {
      const { Template_Connectors: connectors } = template
      const connectorPosition = connectors.findIndex(({ template_connector_id }) => {
        return template_connector_id === templateConnector.template_connector_id
      })

      if (connectorPosition >= 0) return template.Template_Connectors.splice(connectorPosition, 1)
    }
  },
  updateTemplateAttribute (state, template_attribute) {
    let block = state.blocks.find(b => b.block_id == template_attribute.block_id)
    if (block && block.Templates) {
      let template = block.Templates.find(t => t.template_id == template_attribute.template_id)
      if (template) {
        let template_attribute_index = template.Template_Attributes.findIndex(tc => tc.template_attribute_id == template_attribute.template_attribute_id)
        if (template_attribute_index >= 0) {
          template.Template_Attributes.splice(template_attribute_index, 1, template_attribute)
        }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${template_attribute.block_id}`)
        })
      }
    }
  },
  appendElement (state, element) {
    let block = state.blocks.find(b => b.block_id == element.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == element.template_id)
      if (template) {
        element.isNew = true
        template.Elements.push(element)

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${element.block_id}`)
          EventBus.$emit('jsplumb:createElementConnectorEndpoint', element.Element_Connectors.map(e => e.element_connector_id))
        })
      }
    }
  },
  updateElement (state, element) {
    let block = state.blocks.find(b => b.block_id == element.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == element.template_id)
      if (template) {
        let element_index = template.Elements.findIndex(e => e.element_id == element.element_id)
        if (element_index >= 0) {
          template.Elements.splice(element_index, 1, element)
        }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${element.block_id}`)
        })
      }
    }
  },
  removeElement (state, element) {
    let block = state.blocks.find(b => b.block_id == element.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == element.template_id)
      if (template) {
        let element_index = template.Elements.findIndex(e => e.element_id == element.element_id)
        if (element_index >= 0) {
          // delete element connectors endpoints
          let Element = template.Elements[element_index]
          for (let element_connector of Element.Element_Connectors) {
            EventBus.$emit('jsplumb:destroyEndpoint', `element_connector_${element_connector.element_connector_id}`)
          }

          template.Elements.splice(element_index, 1)
        }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${element.block_id}`)
        })
      }
    }
  },
  updateElementAttribute (state, element_attribute) {
    let block = state.blocks.find(b => b.block_id == element_attribute.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == element_attribute.template_id)
      if (template) {
        let element = template.Elements.find(e => e.element_id == element_attribute.element_id)
        if (element) {
          let element_attribute_index = element.Element_Attributes.findIndex(ea => ea.element_attribute_id == element_attribute.element_attribute_id)
          if (element_attribute_index >= 0) {
            element.Element_Attributes.splice(element_attribute_index, 1, element_attribute)
          }

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${element_attribute.block_id}`)
          })
        }
      }
    }
  },
  appendElementConnector (state, element_connector) {
    const block = state.blocks.find(b => b.block_id == element_connector.block_id)
    if (block && block.Templates) {
      const template = block.Templates.find(t => t.template_id == element_connector.template_id)
      if (template && template.Elements) {
        const element = template.Elements.find(e => e.element_id == element_connector.element_id)
        if (element && element.Element_Connectors) {
          element.Element_Connectors.push(element_connector)

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${element_connector.block_id}`)
            EventBus.$emit('jsplumb:createElementConnectorEndpoint', element.Element_Connectors.map(ec => ec.element_connector_id))
          })
        }
      }
    }
  },
  updateElementConnector (state, element_connector) {
    const block = state.blocks.find(b => b.block_id == element_connector.block_id)
    if (block && block.Templates) {
      const template = block.Templates.find(t => t.template_id == element_connector.template_id)
      if (template && template.Elements) {
        const element = template.Elements.find(e => e.element_id == element_connector.element_id)
        if (element && element.Element_Connectors) {
          const element_connector_index = element.Element_Connectors.findIndex(ea => ea.element_connector_id == element_connector.element_connector_id)
          if (element_connector_index >= 0) {
            element.Element_Connectors.splice(element_connector_index, 1, element_connector)
          }

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${element_connector.block_id}`)
            EventBus.$emit('connector:change', {
              sourceId: `element_connector_${element_connector.element_connector_id}`,
              targetId: `block_${element_connector.next_block_id}`,
              connector: element_connector
            })
          })
        }
      }
    }
  },
  deleteElementConnector (state, element_connector) {
    const block = state.blocks.find(b => b.block_id == element_connector.block_id)
    if (block && block.Templates) {
      const template = block.Templates.find(t => t.template_id == element_connector.template_id)
      if (template && template.Elements) {
        const element = template.Elements.find(e => e.element_id == element_connector.element_id)
        if (element && element.Element_Connectors) {
          const element_connector_index = element.Element_Connectors.findIndex(ea => ea.element_connector_id == element_connector.element_connector_id)
          if (element_connector_index >= 0) {
            EventBus.$emit('jsplumb:destroyEndpoint', `element_connector_${element_connector.element_connector_id}`)
            element.Element_Connectors.splice(element_connector_index, 1)
          }

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${element_connector.block_id}`)
          })
        }
      }
    }
  },
  async reorderBlocksTemplates (state, data) {
    let block = state.blocks.find(b => b.block_id == data.block_id)
    if (block) {
      block.Templates.splice(data.newIndex, 0, block.Templates.splice(data.oldIndex, 1)[0])

      block.Templates.forEach((tc, index) => {
        tc.number = index + 1
      })

      try {
        await Vue.request.post(`block/${data.block_id}/sort_templates`, { templates: block.Templates.map(t => t.template_id) })
      } catch (e) { console.error(e.message) }

      Vue.prototype.$nextTick(() => {
        EventBus.$emit('jsplumb:repaint', `block_${data.block_id}`)
      })
    }
  },
  async reorderTemplateConnectors (state, data) {
    let block = state.blocks.find(b => b.block_id == data.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == data.template_id)
      if (template) {
        let array = template.Template_Connectors.filter(tc => tc.type == (data.quickReplies ? 'quick_reply' : 'payload'))
        let newIndex = template.Template_Connectors.findIndex(tc => tc.template_connector_id == array[data.newIndex].template_connector_id)
        let oldIndex = template.Template_Connectors.findIndex(tc => tc.template_connector_id == array[data.oldIndex].template_connector_id)
        template.Template_Connectors.splice(newIndex, 0, template.Template_Connectors.splice(oldIndex, 1)[0])

        template.Template_Connectors.filter(tc => tc.type == (data.quickReplies ? 'quick_reply' : 'payload')).forEach((tc, index) => {
          tc.number = index + 1
        })

        try {
          await Vue.request.post(`template/${data.template_id}/sort_template_connectors`, { template_connectors: template.Template_Connectors.map(tc => tc.template_connector_id) })
        } catch (e) { console.error(e.message) }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${data.block_id}`)
        })
      }
    }
  },
  async reorderElements (state, data) {
    let block = state.blocks.find(b => b.block_id == data.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == data.template_id)
      if (template) {
        template.Elements.splice(data.newIndex, 0, template.Elements.splice(data.oldIndex, 1)[0])

        template.Elements.forEach((tc, index) => {
          tc.number = index + 1
        })

        try {
          await Vue.request.post(`template/${data.template_id}/sort_elements`, { elements: template.Elements.map(e => e.element_id) })
        } catch (e) { console.error(e.message) }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${data.block_id}`)
        })
      }
    }
  },
  async reorderElementConnectors (state, data) {
    let block = state.blocks.find(b => b.block_id == data.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == data.template_id)
      if (template) {
        let element = template.Elements.find(e => e.element_id == data.element_id)
        if (element) {
          element.Element_Connectors.splice(data.newIndex, 0, element.Element_Connectors.splice(data.oldIndex, 1)[0])

          element.Element_Connectors.forEach((tc, index) => {
            tc.number = index + 1
          })

          try {
            await Vue.request.post(`element/${data.element_id}/sort_element_connectors`, { element_connectors: element.Element_Connectors.map(ec => ec.element_connector_id) })
          } catch (e) { console.error(e.message) }

          Vue.prototype.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint', `block_${data.block_id}`)
          })
        }
      }
    }
  },
  appendTemplatePlatform (state, platform) {
    let block = state.blocks.find(b => b.block_id == platform.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == platform.template_id)
      if (template) {
        template.Platforms.push(platform)

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${platform.block_id}`)
        })
      }
    }
  },
  removeTemplatePlatform (state, platform) {
    let block = state.blocks.find(b => b.block_id == platform.block_id)
    if (block) {
      let template = block.Templates.find(t => t.template_id == platform.template_id)
      if (template) {
        let platformIndex = template.Platforms.findIndex(p => p.platform_id == platform.platform_id)
        if (platformIndex >= 0) {
          template.Platforms.splice(platformIndex, 1)
        }

        Vue.prototype.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${platform.block_id}`)
        })
      }
    }
  },
  setFavoriteBlocks (state, items) {
    state.favorite_blocks = items
  },
  pushFavorite (state, block) {
    state.favorite_blocks.push(block)
  },
  removeFavorite (state, block) {
    let index = state.favorite_blocks.findIndex(b => b.block_id == block.block_id)
    if (index >= 0) {
      state.favorite_blocks.splice(index, 1)
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
